import { DeviceType, Orientation } from 'sofa-reborn-react';
import styled from 'styled-components';

type Attributes = {
	pointerOverDropArea: boolean;
};

function getOpacity(props: Attributes): string {
	return props.pointerOverDropArea === true
		? `
				opacity: 0.7;
		  `
		: `
				opacity: 1;
		  `;
}

export const DivDeleteOverlay = styled.div<{
	pointerOverDropArea: boolean;
	orientation: Orientation;
	deviceType: DeviceType;
}>`
	${(props): string =>
		`
			display: flex;
			background-color: rgba(255, 255, 255, 0.9);
			position: absolute;
			${props.orientation !== 'portrait' && 'top: 0;'};
			${props.orientation !== 'portrait' && 'left: 0;'};
			z-index: 2;
			height: ${
				props.orientation === 'portrait'
					? props.deviceType === 'mobile'
						? '110px'
						: '150px'
					: '100%'
			};
			width: 100%;
			align-items: center;
			${getOpacity(props)};
			transition: opacity 0.3s ease-in-out;
		`}
`;
